import React, { useEffect } from 'react';
import CookieConsent from 'react-cookie-consent';
import {
  CONSENT_COOKIE,
  consentStatus,
  grantConsent,
  denyConsent,
  hasDNT,
} from './consent';
import {
  enableAnalyticsNow,
  disableAnalyticsNow,
  logEventSafe,
} from './analytics';

export default function ConsentBanner() {
  useEffect(() => {
    if (hasDNT()) {
      disableAnalyticsNow();
      return;
    }
    if (consentStatus() === 'granted') {
      enableAnalyticsNow().then(() => logEventSafe('consent_restored'));
    }
  }, []);

  if (hasDNT() || consentStatus() !== 'unset') return null;

  return (
    <CookieConsent
      location="bottom"
      cookieName={CONSENT_COOKIE}
      buttonText="Accept"
      declineButtonText="Reject"
      enableDeclineButton
      sameSite="lax"
      expires={365 * 5}
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        maxWidth: 'none',
        padding: '16px 24px',
        background: 'rgba(31,41,55,0.95)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.35)',
        color: '#e5e7eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        zIndex: 9999,
      }}
      contentStyle={{
        margin: 0,
        padding: 0,
        color: '#e5e7eb',
        fontSize: 14,
        lineHeight: 1.45,
        flex: '1 1 auto',
      }}
      buttonWrapperClasses="flex items-center gap-1 shrink-0 pr-2"
      buttonStyle={{
        appearance: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '10px 14px',
        borderRadius: 8,
        fontWeight: 700,
        fontSize: 14,
        background: '#4f46e5',
        color: '#fff',
        boxShadow: '0 1px 2px rgba(0,0,0,0.25)',
        transition: 'transform 120ms ease, background 120ms ease',
        minWidth: 110,
        textAlign: 'center',
      }}
      declineButtonStyle={{
        appearance: 'none',
        cursor: 'pointer',
        padding: '10px 14px',
        borderRadius: 8,
        fontWeight: 700,
        fontSize: 14,
        background: 'transparent',
        color: '#e5e7eb',
        border: '1px solid rgba(255,255,255,0.16)',
        transition: 'transform 120ms ease, border-color 120ms ease, background 120ms ease',
        minWidth: 110,
        textAlign: 'center',
      }}
      ButtonComponent={(props) => {
        const isDecline = props.children === 'Reject';
        return (
          <button
            {...props}
            onMouseEnter={(e) => {
              if (isDecline) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
              } else {
                e.currentTarget.style.background = '#4338ca';
              }
            }}
            onMouseLeave={(e) => {
              if (isDecline) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.16)';
              } else {
                e.currentTarget.style.background = '#4f46e5';
              }
              e.currentTarget.style.transform = 'scale(1)';
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = 'scale(0.98)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          />
        );
      }}
      onAccept={() => {
        grantConsent();
        enableAnalyticsNow().then(() => {
          logEventSafe('consent_granted');
        });
      }}
      onDecline={() => {
        denyConsent();
        disableAnalyticsNow();
      }}
    >
      <div className="unselectable" style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>
        Help us improve your experience
      </div>
      <div className="unselectable" style={{ fontSize: 13.5, color: '#d1d5db', marginTop: 2 }}>
        We use analytics to understand how our site is used and make it faster and more useful for you.
        {' '}We won't set these cookies unless you choose <span style={{ color: '#fff' }}>Accept</span>.
        {' '}Learn more in our&nbsp;
        <a href="/policies" style={{ color: '#93c5fd', textDecoration: 'none' }}>
          Privacy Policy & Terms
        </a>.
      </div>
    </CookieConsent>
  );
}
